import { Popup } from '../../../../components/Popup'
import { Typography } from '../../../../components/Typography'
import { useContractDetailsContext } from '../../Providers/ContractDetailsContextProvider'
import { useContractDetailsPopup } from '../../Providers/ContractDetailsPopupProvider'
import { useCallback, useLayoutEffect, useMemo, useState } from 'react'
import { Button, BUTTON_TYPES } from '../../../../components/Button'
import {
  BTN_TXT,
  PLACEHOLDERS,
  VALIDATION_MESSAGES
} from '../../../../constants'
import { Datepicker } from '../../../../components/Datepicker'

import moment, { Moment } from 'moment'
import './styles.scss'
import { updateContractTerminationDateRequestAsync } from '../../api'
import { useDispatch } from 'react-redux'
import { setLoading } from '../../../../redux/store/common/slice'
import { notification } from '../../../../components/Notification'
import { AxiosResponse } from 'axios'

const TerminateContractWithDate = () => {
  const dispatch = useDispatch()
  const contractDetailsContext = useContractDetailsContext()
  const { terminateContractWithDatePopup } = useContractDetailsPopup()

  const { details } = contractDetailsContext.state
  const { getContractDetailsAsync } = contractDetailsContext.actions

  const { setState, close } = terminateContractWithDatePopup.actions

  const [date, setDate] = useState<Moment | null>(null)

  const handleClickTerminateContract = useCallback(async () => {
    try {
      dispatch(setLoading(true))
      await updateContractTerminationDateRequestAsync(details.uuid, {
        termination_date: moment(date).format('YYYY-MM-DD')
      })
      notification.success({
        message: VALIDATION_MESSAGES.SM0173
      })
      terminateContractWithDatePopup.actions.close()
      await getContractDetailsAsync()
    } catch (e) {
      const err = e as AxiosResponse
      if (err?.data?.termination_date) {
        notification.error({ message: err?.data.termination_date[0] })
      }
      console.error(err)
    } finally {
      dispatch(setLoading(false))
    }
  }, [
    date,
    details.uuid,
    dispatch,
    getContractDetailsAsync,
    terminateContractWithDatePopup.actions
  ])

  const validateDate = (_, value: Moment) => {
    const today = moment().startOf('day')

    if (!value) {
      return Promise.resolve()
    }

    if (value.isBefore(today)) {
      return Promise.reject('The date cannot be in the past')
    }

    if (details.finish_date && value.isAfter(moment(details.finish_date))) {
      return Promise.reject(
        'The date overlaps the current finish date. \n' +
          'Please pick another date '
      )
    }

    return Promise.resolve()
  }

  const Footer = useMemo(
    () => (
      <>
        <Button type={BUTTON_TYPES.DEFAULT} onClick={close} upperCase>
          {BTN_TXT.BACK_TO_DETAILS}
        </Button>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          onClick={handleClickTerminateContract}
          danger
          disabled={!date}
          upperCase
        >
          {BTN_TXT.TERMINATE_CONTRACT}
        </Button>
      </>
    ),
    [close, date, handleClickTerminateContract]
  )

  useLayoutEffect(() => {
    setState((prevState) => ({
      ...prevState
    }))
  }, [details.contract_category_name, setState])
  return (
    <Popup
      {...terminateContractWithDatePopup.state}
      width={442}
      footer={Footer}
      className="termination-contract-modal"
    >
      <Typography.Body1>
        You are about to end {details.vendor?.name}'s{' '}
        {details.contract_category_name} agreement. The vendor and all relevant
        users will be notified about the termination.
      </Typography.Body1>
      <div className="datepicker-wrapper mt-16">
        <Datepicker
          propsDate={{
            placeholder: PLACEHOLDERS.MM_DD_YYYY,
            value: date,
            onChange: setDate,
            disabledDate: (current) =>
              current.isBefore(moment().subtract(1, 'day'))
          }}
          propsItem={{
            label: 'Date of termination',
            required: true,
            rules: [{ validator: validateDate }]
          }}
        />
      </div>
    </Popup>
  )
}

export default TerminateContractWithDate
